import { TCountryCodes } from '@/shared/models/country-code';

import { TUploadScope } from '../RelatedInfo/config';

import { CLEAN_RECORD_DOC_TYPES, CLEAN_RECORD_GROUP } from './clean-record';
import { INSURANCE_DOC_TYPES, INSURANCE_GROUP } from './insurance';
import { ISupplementaryDocsGroup } from './types';

const SUPPLEMENTARY_DOCS_BY_DOC_TYPE: Record<
  TUploadScope,
  Partial<Record<string, ISupplementaryDocsGroup>>
> = {
  myDriver: {
    [CLEAN_RECORD_DOC_TYPES.certificate]: CLEAN_RECORD_GROUP,
  },
  driver: {
    [CLEAN_RECORD_DOC_TYPES.certificate]: CLEAN_RECORD_GROUP,
  },
  car: {
    [INSURANCE_DOC_TYPES.certificate]: INSURANCE_GROUP,
  },
};

const getSupplementaryGroups = (
  scope: TUploadScope,
  region: TCountryCodes,
): Partial<Record<string, ISupplementaryDocsGroup>> =>
  Object.fromEntries(
    Object.entries(SUPPLEMENTARY_DOCS_BY_DOC_TYPE[scope]).filter(([, group]) =>
      group?.countries.includes(region),
    ),
  );

export { SUPPLEMENTARY_DOCS_BY_DOC_TYPE, getSupplementaryGroups };
